import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useIsMobile } from '../hooks/useIsMobile';
import Sidebar from './Sidebar';
import ClinicAgentPanel from './agent/ClinicAgentPanel';

const AppShell: React.FC = () => {
  const { access } = useAuth();
  const isMobile = useIsMobile();

  if (!access) {
    return <Navigate to="/login" />;
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      <main
        style={{
          flex: 1,
          minWidth: 0,
          marginLeft: isMobile ? 0 : 240,
          background: '#f9fafb',
          minHeight: '100vh',
        }}
      >
        <Outlet />
      </main>
      <ClinicAgentPanel />
    </div>
  );
};

export default AppShell;
